import * as React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import { nanoid } from "nanoid";
const Button = ({ link, title = "", className = "", alt = "" }) => {
  if (
    link &&
    link.indexOf("http://") === -1 &&
    link.indexOf("https://") === -1
  ) {
    return (
      <>
        <div key={nanoid()}>
          <Link to={link} title={title}>
            <h2 className={`p-4 ${className}`}>{title}</h2>
          </Link>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div key={nanoid()}>
          <a href={link} target="_blank" rel="noreferrer noopener" alt={title}>
            <h2 className={`p-4 ${className}`}>{title}</h2>
          </a>
        </div>
      </>
    );
  }
};

Button.propTypes = {
  body: PropTypes.object,
  title: PropTypes.string,
  link: PropTypes.string,
};

export default Button;
